import { Link } from "react-router-dom";

const friendLinks = [
  { label: "电视剧频道", to: "/category/电视剧" },
  { label: "电影频道", to: "/category/电影" },
  { label: "全部搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-100">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-8 py-12 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">恋爱的味道</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              专注情感类影视作品的资源分享与剧情介绍，汇聚爱情电视剧、经典电影与海外佳作，陪你在光影里感受浪漫与温馨。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">友情链接</h4>
            <ul className="mt-4 space-y-2">
              {friendLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-primary-500"></i>
                <span>hello@lianaideweidao.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base text-primary-500"></i>
                <span>每日 09:00 - 22:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-secondary-200 py-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © 2026 恋爱的味道 · 本站影视信息均为演示内容，仅供学习交流
          </p>
          <p className="text-xs text-foreground-600">
            用心挑选每一段浪漫 · Made with care
          </p>
        </div>
      </div>
    </footer>
  );
}